import PlansBlockPlanPreview from "./PlansBlockPlanPreview";

export default PlansBlockPlanPreview;